import { toString30pk9tzaqopn as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  equals2au1ep9vhcato as equals,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Data_getInstance1oeb8obtiom5s as Data_getInstance } from './adapter/CreateSecretMutation_ResponseAdapter.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { CreateSecretMutation_VariablesAdapter_instance1eiqalsklrcs8 as CreateSecretMutation_VariablesAdapter_instance } from './adapter/CreateSecretMutation_VariablesAdapter.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(createSecret) {
        this.x6d_1 = createSecret;
      }
      toString() {
        return 'Data(createSecret=' + toString(this.x6d_1) + ')';
      }
      hashCode() {
        return this.x6d_1 == null ? 0 : this.x6d_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!equals(this.x6d_1, other.x6d_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CreateSecretClass;
function CreateSecret() {
  if (CreateSecretClass === VOID) {
    class $ {
      constructor(secretId, description, createdTimestamp, lastUsedTimestamp, secretToken) {
        this.y6d_1 = secretId;
        this.z6d_1 = description;
        this.a6e_1 = createdTimestamp;
        this.b6e_1 = lastUsedTimestamp;
        this.c6e_1 = secretToken;
      }
      toString() {
        return 'CreateSecret(secretId=' + this.y6d_1.toString() + ', description=' + this.z6d_1 + ', createdTimestamp=' + this.a6e_1.toString() + ', lastUsedTimestamp=' + toString(this.b6e_1) + ', secretToken=' + this.c6e_1 + ')';
      }
      hashCode() {
        var result = this.y6d_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.z6d_1) | 0;
        result = imul(result, 31) + this.a6e_1.hashCode() | 0;
        result = imul(result, 31) + (this.b6e_1 == null ? 0 : this.b6e_1.hashCode()) | 0;
        result = imul(result, 31) + getStringHashCode(this.c6e_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CreateSecret()))
          return false;
        if (!this.y6d_1.equals(other.y6d_1))
          return false;
        if (!(this.z6d_1 === other.z6d_1))
          return false;
        if (!this.a6e_1.equals(other.a6e_1))
          return false;
        if (!equals(this.b6e_1, other.b6e_1))
          return false;
        if (!(this.c6e_1 === other.c6e_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'CreateSecret');
    CreateSecretClass = $;
  }
  return CreateSecretClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.d6e_1 = 'ebc30c0645cf276dd3d78eb42594ec195bdc601bd1d9fe71ba29e8b002fabc48';
        this.e6e_1 = 'createSecret';
      }
      f6e() {
        return 'mutation createSecret($input: CreateSecretInput!) { createSecret(input: $input) { secretId description createdTimestamp lastUsedTimestamp secretToken } }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var CreateSecretMutationClass;
function CreateSecretMutation() {
  if (CreateSecretMutationClass === VOID) {
    class $ {
      constructor(input) {
        this.g6e_1 = input;
      }
      h6e() {
        return 'ebc30c0645cf276dd3d78eb42594ec195bdc601bd1d9fe71ba29e8b002fabc48';
      }
      operationId() {
        return this.h6e();
      }
      g48() {
        return Companion_instance.f6e();
      }
      i6e() {
        return 'createSecret';
      }
      operationName() {
        return this.i6e();
      }
      a47(writer, customScalarAdapters, withDefaultValues) {
        CreateSecretMutation_VariablesAdapter_instance.j6e(writer, this, customScalarAdapters, withDefaultValues);
      }
      z46() {
        return obj(Data_getInstance());
      }
      toString() {
        return 'CreateSecretMutation(input=' + this.g6e_1.toString() + ')';
      }
      hashCode() {
        return this.g6e_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CreateSecretMutation()))
          return false;
        if (!this.g6e_1.equals(other.g6e_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'CreateSecretMutation', VOID, VOID, [Mutation()]);
    CreateSecretMutationClass = $;
  }
  return CreateSecretMutationClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  CreateSecret as CreateSecretg99oj6r6hso0,
  Data as Data1ybn66w6c74sz,
  CreateSecretMutation as CreateSecretMutation3m5frrt825225,
};
//endregion

//# sourceMappingURL=CreateSecretMutation.mjs.map
